// @flow
import { styled } from 'linaria/react';
export const Header =
/*#__PURE__*/
styled("div")({
  name: "Header",
  class: "h2pbki2"
});